import { PositiveFeedbackComponent } from 'settings/Settings.types';

import * as Styled from './RewardsTabs.styled';

function isRewardEnum(value): value is PositiveFeedbackComponent {
  return Object.values(PositiveFeedbackComponent).includes(value);
}

export function RewardsTabs({
  activeTab,
  onTabClick = () => {},
}: RewardsTabsProps) {
  return (
    <Styled.Tabs
      activeTabValue={activeTab}
      tabs={[
        {
          label: <Styled.TabItem>Areas of Excellence</Styled.TabItem>,
          value: PositiveFeedbackComponent.AreasOfExcellence,
          disabled: activeTab === undefined,
        },
        {
          label: <Styled.TabItem>Rewards</Styled.TabItem>,
          value: PositiveFeedbackComponent.Rewards,
          disabled: activeTab === undefined,
        },
      ]}
      onTabClick={(ev, tab) => {
        const { value } = tab;
        // This may seem repetitive, but as `tab` returns a TabProps
        // object where `TabProps['value']` is a `string`. We'll have to use
        // a function that returna a type-predicate, ensuring TypeScript that
        // value is effectively a `PositiveFeedbackComponent` value.
        if (isRewardEnum(value) && activeTab !== undefined) {
          onTabClick(value);
        }
      }}
    />
  );
}

interface RewardsTabsProps {
  activeTab?: PositiveFeedbackComponent;
  onTabClick?: (selectedTab: PositiveFeedbackComponent) => void;
}
